<template>
  <v-container fluid>
		<v-btn-toggle
			v-model="selectedType"
			v-if="showSelector"
			dense
			class="d-flex flex-row mb-3 custom-toggle-btns"
		>
			<v-btn :value="1" class="flex-grow-1"
				:color="selectedType == 1 ? '#FF1209':''">
				<p class="mb-0 caption font-weight-bold" :class="selectedType == 1 ? 'white--text':''">Configuración Para Contrato Clientes</p>
			</v-btn>
			<v-btn :value="2" class="flex-grow-1"
				:color="selectedType == 2 ? '#FF1209':''">
				<p class="mb-0 caption font-weight-bold" :class="selectedType == 2 ? 'white--text':''">Configuración Para Subcontrato Proveedores</p>
			</v-btn>
		</v-btn-toggle>
		<div v-else class="d-flex align-center py-1 px-3 mb-3" style="background-color: #FF1209;border-radius: 4px;">
			<p class="mb-0 font-weight-bold white--text">Configuración Para {{selectedType == 1 ? 'Contrato Clientes':'Subcontrato Proveedores'}}</p>
		</div>
		<v-row>
			<v-col cols="5">
				<div class="mb-3 d-flex justify-space-between align-center">
					<p class="mb-0 caption font-weight-bold">Categorías / Cláusulas para {{selectedType == 1 ? 'Contrato Clientes':'Subcontrato Proveedores'}}</p>
					<v-btn
						depressed
						color="#959595"
						x-small
						outlined
						class="my-0"
						v-if="$checkPermissions(['create_company_project_types'])"
						@click="newContractCategory"
					>
						<v-icon small>mdi-plus</v-icon>
						<p class="mb-0 ml-1 caption">Nueva Categoría</p>
					</v-btn>
				</div>
				<v-data-table
					:headers="headersCat"
					:items="companyContractCategories"
					:search="search"
					item-key="id"
					:loading="$store.state.contracts.loadingCompanyContractCategories"
					loading-text="Cargando datos..."
					:footer-props="{
						itemsPerPageText: 'Filas por página'
					}"
					:items-per-page="-1"
					hide-default-footer
				>
					<template v-slot:body="{ items }">
						<draggable
							v-model="companyContractCategories"
							tag="tbody"
							item-key="id"
							@end="startEndDragEventCategory"
						>
							<tr v-for="(item) in items" :key="item.id" style="cursor: pointer;" @click="selectRow(item)" :class="selectedRowClass(item)">
								<td style="cursor: pointer;">{{ item.title }} ({{ item.sections_count }})</td>
								<td>
									<div>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													x-small
													color="#959595"
													class="mx-1"
													v-if="$checkPermissions(['edit_company_roles'])"
													@click="selectedCategory = item"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-chevron-right</v-icon>
												</v-btn>
											</template>
											<span>Visualizar Secciones</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													x-small
													color="warning"
													class="mx-1"
													v-if="$checkPermissions(['edit_company_roles'])"
													@click="editCategory(item)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-pencil-outline</v-icon>
												</v-btn>
											</template>
											<span>Editar</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													x-small
													color="error"
													class="mx-1"
													v-if="$checkPermissions(['delete_company_roles'])"
													@click="deleteSectionCategory(item.id)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-delete-outline</v-icon>
												</v-btn>
											</template>
											<span>Eliminar</span>
										</v-tooltip>
									</div>
								</td>
							</tr>
						</draggable>
					</template>
				</v-data-table>
			</v-col>
			<v-col cols="7">
				<div class="mb-3 d-flex justify-space-between align-center">
					<p class="mb-0 caption font-weight-bold">Secciones para  {{selectedType == 1 ? 'Contrato Clientes':'Subcontrato Proveedores'}}</p>
					<v-btn
						depressed
						color="#959595"
						x-small
						outlined
						class="my-0"
						v-if="$checkPermissions(['create_company_project_types'])"
						:disabled="!selectedCategory"
						@click="newContractSection"
					>
						<v-icon small>mdi-plus</v-icon>
						<p class="mb-0 ml-1 caption">Nueva Sección en Categoría</p>
					</v-btn>
				</div>
				<v-data-table
					:headers="headers"
					:items="$store.state.contracts.companyContracts"
					:search="search"
					item-key="id"
					:loading="$store.state.contracts.loadingCompanyContracts"
					loading-text="Cargando datos..."
					:footer-props="{
						itemsPerPageText: 'Filas por página'
					}"
					:items-per-page="-1"
					hide-default-footer
					no-data-text="Aún no hay secciones para esta categoría"
				>
					<template v-slot:body="{ items }">
						<draggable
							v-model="$store.state.contracts.companyContracts"
							tag="tbody"
							item-key="id"
							@end="startEndDragEvent"
						>
							<tr v-for="(item) in items" :key="item.id" style="cursor: pointer;">
								<td style="cursor: pointer;">{{ item.title }}</td>
								<td style="cursor: pointer;max-width: 400px;">
									<div class="custom-html-content" v-html="transformPlaceholdersToFriendlyView(item.content)"></div>
								</td>
								<td>
									<div>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													x-small
													color="warning"
													class="mx-1"
													v-if="$checkPermissions(['edit_company_roles'])"
													@click="editSection(item)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-pencil-outline</v-icon>
												</v-btn>
											</template>
											<span>Editar</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													x-small
													color="error"
													class="mx-1"
													v-if="$checkPermissions(['delete_company_roles']) && item.restrictions?.allow_company_delete"
													@click="deleteSection(item.id)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-delete-outline</v-icon>
												</v-btn>
											</template>
											<span>Eliminar</span>
										</v-tooltip>
									</div>
								</td>
							</tr>
						</draggable>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
  </v-container>
</template>

<script>
import {deleteContractSection, updateContractSectionOrders, deleteContractSectionCategory, updateContractSectionCategoryOrders} from '@/helpers/api/contracts'
import { placeholderMapping } from '@/components/Helpers/Constants/contract'
import draggable from "vuedraggable"
import _debounce from 'lodash/debounce'

export default {
  components: {
    draggable,
  },
  data() {
    return {
			placeholderMapping,
      search: '',
			showSelector: true,
			selectedRowItem: null,
			selectedCategory: null,
			selectedType: 1,
      headersCat: [
        { text: 'Título', value: 'title' },
        { text: 'Acciones', width: '30%', value: 'actions', sortable: false },
      ],
      headers: [
        { text: 'Título', value: 'title' },
        { text: 'Contenido', value: 'content' },
        { text: 'Acciones', width: '100px', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
		companyContractCategories(){
			return this.$store.state.contracts.companyContractCategories.filter(cat => cat.section_type != 3)
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
		selectedCategory(newValue){
			if(newValue){
				this.$store.dispatch('contracts/getCompanyContractsConfig', {category_id: this.selectedCategory.id, start: 0, limit: 100})
			}
		},
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('contracts/getCompanyContractCategoriesConfig', {type: this.selectedType, start: 0, limit: 100})
			}
		},
		selectedType(newValue){
			if(newValue){
				if(this.showSelector){
					let hash = '#contract'
					if(newValue == 2){
						hash = '#subcontract'
					}
					window.history.replaceState(null, null, hash)
				}
				this.$store.commit('contracts/setCompanyContracts', [])
				this.$store.dispatch('contracts/getCompanyContractCategoriesConfig', {type: this.selectedType, start: 0, limit: 100})
			}
		}
	},
	mounted(){
		const currentHash = this.$route.hash || window.location.hash
		if(currentHash){
			const hashConfig = {
				'#contract':        { type: 1, show: true },
				'#contract-only':   { type: 1, show: false },
				'#subcontract':     { type: 2, show: true },
				'#subcontract-only':{ type: 2, show: false }
			}

			if (hashConfig[currentHash]) {
				const { type, show } = hashConfig[currentHash]
				this.showSelector = show
				this.selectedType = type
			}
		}
		if(this.selectedCompany){
			this.$store.dispatch('contracts/getCompanyContractCategoriesConfig', {type: this.selectedType, start: 0, limit: 100})
		}
	},
  methods: {
		selectRow(item){
			this.selectedCategory = item
			this.selectedRowItem = item.id
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		transformPlaceholdersToFriendlyView(content) {
			let result = content;
			for (const [placeholder, label] of Object.entries(this.placeholderMapping)) {
				const regex = new RegExp(placeholder, 'g');
				result = result.replace(regex, `<span class="friendly-placeholder" style="font-size: 12px;padding: 1px 6px;border: 1px solid grey;border-radius: 5px;background: white;color:orange;" contenteditable="false">${label}</span>`);
			}
			return result;
		},
		newContractCategory(){
			const order = this.companyContractCategories.length + 1
			this.$store.commit('contracts/setModalCategoryEditing', { order, type: this.selectedType })
			this.$store.commit('contracts/setModalCategory', true)
		},
		newContractSection(){
			if(this.selectedCategory){
				const data = {
					title: null,
					code: null,
					type: 1,
					order: this.selectedCategory.sections_count + 1,
					content: null,
					category_id: this.selectedCategory.id,
				}
				this.$store.commit('contracts/setModalSectionEditing', data)
				this.$store.commit('contracts/setModalSection', true)
			}
			else{
				const messageData = {
					message: 'Primero selecciona una categoría',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		startEndDragEventCategory: _debounce(function(ev){ this.endDragEventCategory(ev) }, 800),
		async endDragEventCategory(ev){
			if (typeof ev.newIndex === 'number') {
				const categories = this.companyContractCategories.map((category, index) => {
					return { order: index + 1, id: category.id}
				})
				await updateContractSectionCategoryOrders({categories})
				this.$store.dispatch('contracts/getCompanyContractCategoriesConfig', {type: this.selectedType, start: 0, limit: 100})
			}
		},
		startEndDragEvent: _debounce(function(ev){ this.endDragEvent(ev) }, 800),
		async endDragEvent(ev){
			if (typeof ev.newIndex === 'number') {
				const sections = this.$store.state.contracts.companyContracts.map((section, index) => {
					return { order: index + 1, id: section.id}
				})
				await updateContractSectionOrders({sections})
				this.$store.dispatch('contracts/getCompanyContractCategoriesConfig', {type: this.selectedType, start: 0, limit: 100})
			}
		},
    editSection(section) {
      const data = {
				...section,
				...{section_id: section.id}
			}
			this.$store.commit('contracts/setModalSectionEditing', data)
			this.$store.commit('contracts/setModalSection', true)
    },
    editCategory(category) {
      const data = {
				...category,
				...{category_id: category.id}
			}
			this.$store.commit('contracts/setModalCategoryEditing', data)
      this.$store.commit('contracts/setModalCategory', true)
    },
    async deleteSectionCategory(category_id) {
      await deleteContractSectionCategory({category_id})
			this.$store.dispatch('contracts/getCompanyContractCategoriesConfig', {type: this.selectedType, start: 0, limit: 100})
    },
    async deleteSection(section_id) {
      await deleteContractSection({section_id})
			this.selectedCategory && this.$store.dispatch('contracts/getCompanyContractsConfig', {category_id: this.selectedCategory.id, start: 0, limit: 100})
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    }
  },
};
</script>

<style scoped>
	.custom-html-content {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
	/deep/ .custom-html-content p {
		margin-bottom: 0;
	}
</style>